import bp from 'babel-polyfill';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import store from './store';
import createRoutes from './routes';
import intersect from './shared/intersect/intersect';

import VModal from "vue-js-modal";
import injector from 'vue-inject';
import VueYoutube from 'vue-youtube';
import PortalVue from 'portal-vue';
import { ReCaptchaPlugin } from "./plugins/ReCaptcha/ReCaptchaPlugin";
import { resolveAppComponent } from './resolve';

require('./services/yandex-counter.service');

Vue.use(bp);
Vue.use(injector);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueAwesomeSwiper);
Vue.use(VModal);
Vue.use(VueYoutube);
Vue.directive('intersect', intersect);
Vue.use(PortalVue);
Vue.use(
  ReCaptchaPlugin,
  { siteKey: '6LeqU9IrAAAAADk1aPkcdA3ybceEIt7U5hTO57Rj', version: 2, hideBadge: false }
);

const router = new VueRouter({
  routes: createRoutes(window.CONTEXT_REGION),
  mode: 'history',
  base: '/award/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  }
});

Vue.config.productionTip = false;
Vue.config.devtools  = true;

/*
import * as Sentry from "@sentry/vue";
import { DEV_CONTEXT, HOSTS } from "../build/dev-config";

const __getHost = () => {
    const host = (process.env.NODE_ENV !== 'production' && DEV_CONTEXT.envType)
      ? (HOSTS[DEV_CONTEXT.regionId] + DEV_CONTEXT.envType)
      : HOSTS[DEV_CONTEXT.regionId]

    return host
      .replace('http://', '')
      .replace('https://', '');
}

Sentry.init({
  vue: Vue,
  release: 'events@v' + process.env.version,
  environment: process.env.NODE_ENV_EXEC,
  debug: process.env.NODE_ENV_EXEC === 'localhost',
  dsn: `https://2b31c1033f9241d589e9a8e32e545cf7@${__getHost()}/award/report/5`,
  tracesSampleRate: 1.0,
  attachStacktrace: true,
  enabled: process.env.NODE_ENV_EXEC !== 'localhost',
  logErrors: true,
});
Vue.config.errorHandler = function (err, vm, info) {
  Sentry.captureException(err, { extra: { vm: vm, info: info } });
  console.error(err);
  console.log(info, vm);
}
*/

new Vue({
  el: '#app',
  components: { App: resolveAppComponent(window.CONTEXT_REGION) },
  store,
  router,
});



// WEBPACK FOOTER //
// ./src/main.js